import React from 'react';
import {useSelector} from 'react-redux';

export const useUserInfo = (index = '', secondIndex) => {
  const userInfo = useSelector((state) => {
    if (secondIndex) {
      return state.user?.info?.[index]?.[secondIndex];
    } else if (index) {
      return state.user?.info?.[index];
    }
    return state.user?.info;
  });

  return userInfo;
};

// location id can come from nav params for classic hunts
// location id can also come from state for regular
export const useUserId = () => {
  const userId = useUserInfo('userId');

  return userId;
};

// location id can come from nav params for classic hunts
// location id can also come from state for regular
export const useUserTicketCount = () => {
  const tickets = useUserInfo('tickets');

  let userTicketCount = 0;
  if (typeof tickets == 'object') {
    console.log('determining themeOptions');
    userTicketCount = Object.values(tickets).reduce(
      (a, b) => a + parseInt(b),
      0,
    );
  }

  return userTicketCount;
};
